import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { WHATSAPP_URL, IMAGES } from "@/data/content";
import { Reveal } from "./anim";

export default function Pricing() {
  const { t } = useLang();
  const p = t.pricing;

  return (
    <section id="pricing" className="relative py-24 md:py-36 bg-cream overflow-hidden" data-testid="pricing-section">
      <div
        className="absolute right-0 top-0 h-full w-1/3 opacity-[0.09] hidden md:block"
        style={{ backgroundImage: `url(${IMAGES.stones})`, backgroundSize: "cover", backgroundPosition: "center" }}
      />
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 relative">
        <Reveal>
          <p className="text-xs tracking-[0.25em] uppercase text-brand mb-6">{p.overline}</p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-[3.75rem] tracking-tight text-ink max-w-2xl">
            {p.title}
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-2 gap-8 lg:gap-14 max-w-4xl">
          {p.plans.map((plan, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1], delay: i * 0.12 }}
              className="group border-t border-ink/15 pt-8"
              data-testid={`plan-${i}`}
            >
              <p className="text-xs tracking-[0.2em] uppercase text-ink-soft">{plan.duration}</p>
              <div className="mt-4 font-serif font-light text-7xl lg:text-8xl text-ink leading-none tracking-tight group-hover:text-brand transition-colors duration-500">
                {plan.price}
              </div>
              <p className="mt-5 font-light text-base leading-relaxed text-ink-soft max-w-sm">{plan.desc}</p>
            </motion.div>
          ))}
        </div>

        <Reveal delay={0.2}>
          <a
            data-testid="pricing-cta"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group mt-16 inline-flex items-center gap-3 rounded-full bg-ink text-cream px-9 py-4 text-xs tracking-[0.18em] uppercase hover:bg-brand transition-colors duration-500"
          >
            {p.cta}
            <span className="inline-block transition-transform duration-500 group-hover:translate-x-1">→</span>
          </a>
        </Reveal>
      </div>
    </section>
  );
}
